<template>
   <div class="layout-contain">
      <div class="layout-nav">
         <div id="header" class="grow container-fluid">
            <div class="navbar navbar-expand-lg navbar-light">
               <a class="navbar-brand header-logo" href="https://www.ManhattanLife.com"> </a>
               <button
                  class="navbar-toggler"
                  type="button"
                  data-toggle="collapse"
                  data-target="#collapsible-menu"
                  aria-controls="collapsible-menu"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
               >
                  <span class="navbar-toggler-icon"></span>
               </button>
               <div
                  class="collapse navbar-collapse justify-content-end align-middle"
                  id="collapsible-menu"
               >
                  <ul class="navbar-nav">
                     <li v-if="isInternalAdmin" class="ml-orange font-italic">
                        {{ internalAdmin.name }}
                     </li>
                     <li class="nav-item">
                        <router-link
                           :to="{ name: 'home' }"
                           data-toggle="collapse"
                           data-target="#collapsible-menu"
                           >DASHBOARD
                           <div class="bbarr"></div
                        ></router-link>
                     </li>
                     <li class="nav-item dropdown" v-if="showDrillDown()">
                        <a
                           class="nav-link dropdown-toggle"
                           href="#"
                           id="configureLink"
                           data-toggle="dropdown"
                           aria-haspopup="true"
                           aria-expanded="false"
                        >
                           CONFIGURE
                           <div class="bbarr"></div>
                        </a>
                        <div class="dropdown-menu" aria-labelledby="configureLink">
                           <router-link :to="{ name: 'corr' }" class="dropdown-item" data-toggle="collapse" data-target="#collapsible-menu"
                              ><i class="fas fa-mail-bulk dropdown-icon"></i> Email Templates</router-link
                           >
                           <router-link :to="{ name: 'invites' }" class="dropdown-item" exact data-toggle="collapse" data-target="#collapsible-menu"
                              ><i class="fi-interface-organization dropdown-icon"></i> Invitations</router-link
                           >
                           <router-link :to="{ name: 'agents' }" class="dropdown-item" exact data-toggle="collapse" data-target="#collapsible-menu"
                              ><i class="fas fa-user dropdown-icon"></i> Agents</router-link
                           >
                           <router-link :to="{ name: 'inprog' }" class="dropdown-item" exact data-toggle="collapse" data-target="#collapsible-menu"
                              ><i class="fas fa-user-edit dropdown-icon"></i> Applications</router-link
                           >
                           <router-link :to="{ name: 'reports' }" class="dropdown-item" exact data-toggle="collapse" data-target="#collapsible-menu"
                              ><i class="fas fa-file-excel dropdown-icon"></i> Reports</router-link
                           >
                        </div>
                     </li>
                     <li v-if="pendingReports > 0">
                        <router-link :to="{ name: 'reports' }" > 
                           <i class="far fa-bell ml-orange svc-icon"></i>
                           <span class="badge badge-pill badge-warning">{{ pendingReports }}</span>
                        </router-link>
                     </li>
                     <li class="nav-item">
                        <a class="logout-link" @click.prevent="logOut" data-toggle="collapse" data-target="#collapsible-menu"
                           >LOGOUT
                           <div class="bbarr"></div
                        ></a>
                     </li>
                     <li class="nav-item align-top dropdown">
                        <a class="nav-link dropdown-toggle"
                           href="#"
                           id="profileDDL"
                           data-toggle="dropdown"
                           aria-haspopup="true"
                           aria-expanded="false"
                        >
                           <i class="fi-interface-user-1 usr-icon"></i>
                           {{ userDisplayName }}
                           <div class="bbarr"></div>
                        </a>
                        <div class="dropdown-menu dropdown-menu-right" aria-labelledby="profileDDL">
                           <a href="#" @click.prevent="editProfile" class="dropdown-item" data-toggle="collapse" data-target="#collapsible-menu">
                              <i class="fi-interface-user-1 dropdown-icon"></i> 
                              Your Profile
                           </a>
                           <router-link :to="{ name: 'faq' }" class="dropdown-item" exact data-toggle="collapse" data-target="#collapsible-menu"
                              ><i class="fi-tech-shield-6 dropdown-icon"></i> FAQ</router-link
                           >
                           <router-link :to="{ name: 'commpref' }" class="dropdown-item" exact data-toggle="collapse" data-target="#collapsible-menu"
                              ><i class="fi-creative-email dropdown-icon"></i> Communications</router-link
                           >
                        </div>
                     </li>
                  </ul>
               </div>
            </div>
         </div>
      </div>

      <vue-topprogress ref="topProgress" color="#00a7a1" colorShadow="transparent" :height="progBarHeight"></vue-topprogress>
      <div class="layout-frame" cloak>
         <slot />
      </div>
      
      <div class="layout-footer container-fluid">
         <div class="row">
            <div class="col">Copyright &copy; {{ year }} MANHATTANLIFE</div>
            <div class="col text-right"><tech-support class="tech-sup-btn"></tech-support></div>
         </div>
      </div>
   </div>
</template>  

<script>
import Vue from "vue";
import { mapGetters } from 'vuex';
import btnTechSupport from "@/components/techSupport"
const TIMEOUT = 20;

export default {
   name: "AuthdLayout",
   components: {
      "tech-support": btnTechSupport
   },   
   data() {
      return {
         windowHeight: 0,
         windowWidth: 0,
         appTitle: process.env.VUE_APP_TITLE,
         year: new Date().getFullYear(),
         usersFirstName: "",
         progBarHeight: 5         
      };
   },
   computed: {
      ...mapGetters(["isInternalAdmin", "internalAdmin", "userClaims"]),
      userDisplayName() {
         if (!this.userClaims) {
            return '';
         }

         if (this.userClaims.given_name && this.userClaims.given_name.trim() !== '') {
            return this.userClaims.given_name;
         }

         return this.userClaims.family_name;
      },
      pendingReports() {
         return this.$store.getters.pendingReports
      }
   },
   async mounted() {
      window.addEventListener("resize", () => {
         this.windowChangedSize();
      });
      window.addEventListener("scroll", this.handleScroll);
      if (this.$route.hash) {
         setTimeout(() => this.scrollTo(this.$route.hash), TIMEOUT);
      }

      await this.$store.dispatch("getPendingReports")
   },
   beforeDestroy() {
      window.removeEventListener("resize", () => {
         this.windowChangedSize();
      });
      window.removeEventListener("scroll", this.handleScroll);
   },
   methods: {
      showDrillDown() {
         let usr = this.$store.getters.appUser
         if (usr && usr.userRoleCode == "USRROLE_MD" || this.$store.getters.hasAppointments) {
            this.$store.commit('updateCheckPendingReports', true)
            return true
         }
         return false
      },
      loadingStart() {
         if (this.$refs.topProgress)
            this.$refs.topProgress.start()
      },
      loadingEnd() {
         if (this.$refs.topProgress)
            this.$refs.topProgress.done()
      },
      async logOut() {
         Vue.prototype.$auth.logout();
      },
      async editProfile() {
         Vue.prototype.$auth.editProfile();
      },
      scrollTo(hashtag) {
         setTimeout(() => {
            location.href = hashtag;
         }, TIMEOUT);
      },
      windowChangedSize: function () {
         this.windowHeight = window.innerHeight;
         this.windowWidth = window.innerWidth;
      },
      handleScroll() {
         // Resize the header when the user scrolls
         var startShrink = 80;
         var he = document.getElementById("header");
         if (window.pageYOffset > startShrink) {
            he.classList.remove("grow");
            he.classList.add("shrink");
         } else {
            he.classList.remove("shrink");
            he.classList.add("grow");
         }
      }
   }
};
</script>

<style lang="scss">
@import "./src/assets/css/site.scss";
@import "./src/assets/css/bell.scss";
.layout-frame {
   background-color: #fff;
   padding: 0 0 36px 0;
}
#pg-nav-row {
   width: 100%;
   padding: 0;
}
.layout-tech-btn {
   position: fixed;
   bottom: 0;
   height: 108px;
   width: 100%;
   display: none;
}
.layout-footer {
   height: 36px;
   font-size: 12px;
   font-weight: 100;
   line-height: 12px;
   color: $corp-color;
   background-color: #000;
   padding: 12px;
   display: flex;
   flex-direction: column;

   position: fixed;
   left: 0;
   bottom: 0;
   z-index: 999;
}
.header-logo {
   min-width: 212px;
}
#nav {
   padding: 30px;
}
.navbar-toggler {
   border: 0;
}
.nav-item {
   padding: 0 12px;
}
.navbar {
   padding: 0;
}
.navbar-nav {
   margin-right: 12px;
}
.nav-item a,
.nav-item a:visited,
.nav-item a:hover {
   min-height: 30px;
   float: left;
   display: block;
   background-color: transparent;
   color: #000;
   text-align: center;
   padding: 8px;
   text-decoration: none;
   cursor: pointer;
   position: relative;
   font-family: corporate-s, "Comic Sans", sans-serif;
   font-size: 18px;
   font-stretch: 100%;
   font-weight: 100;
   font-style: normal;
   letter-spacing: 0.27px;
   line-height: 20px;
}
.navbar-toggler:focus,
.navbar-toggler-icon:focus {
   outline: none;
}
.usr-icon {
   margin-right: 4px;
}
#collapsible-menu {
   height: 100%;
}
.bbarr {
   display: none;
   clear: both;
   width: 100%;
   min-height: 8px;
   height: 8px;
   position: absolute;
   left: 0px;
   top: 36px;
   background-color: $corp-color;
   margin: 0;
   padding: 0;
}
a:hover .bbarr {
   display: block;
   z-index: 1000;
}
.logout-link {
   color: #000;
}
a.nav-link,
a.nav-link:visited {
   color: rgba(0, 0, 0, 1) !important;
   padding: 8px !important;
}
.dropdown-item {
   text-align: left !important;
}
.dropdown-item i {
   color: $corp-color;
   min-width: 28px;
}
.dropdown-item.active {
   background-color: #000 !important;
   color: #fff !important;
}
.dropdown-item:hover {
   background-color: $corp-color !important;
   color: #fff !important;
}
.dropdown-item:hover i {
   color: #fff;
}
.dropdown-icon {
   display: inline-block;
   min-width: 24px !important;
   width: 24px !important;
}
.dropdown-menu, .dropdown-menu:focus {
   outline-color: transparent;
   outline-style: none !important;
   border: 0px !important;
}

</style>